import {MenuItem} from '@ariakit/react'
import {faArrowUpRightFromSquare} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Button} from '@freckle/educator-materials/ts/components/button'
import {Action} from './action'
import {icon, externalLink, menuItem} from './resources.module.scss'

export const ExternalLinkItem = ({
  dataTest,
  text,
  action,
  disabled = false,
}: {
  dataTest: string
  text: string
  action: Action
  disabled?: boolean
}) => {
  const node = (
    <>
      <FontAwesomeIcon icon={faArrowUpRightFromSquare} className={icon} />
      &nbsp;{text}
    </>
  )

  if (action.tag === 'href')
    return (
      <MenuItem
        className={menuItem}
        render={
          <a
            href={action.href}
            target="_blank"
            rel="noopener noreferrer"
            data-test={`navbar-resources-${dataTest}`}
          >
            {node}
          </a>
        }
      />
    )

  return (
    <MenuItem
      className={menuItem}
      data-test={`navbar-resources-${dataTest}`}
      disabled={disabled}
      onClick={e => action.onClick(e)}
      render={
        <div>
          <Button style="link" className={externalLink} onClick={e => action.onClick(e)}>
            {node}
          </Button>
        </div>
      }
    />
  )
}
